import { UserModel } from '@steelbuy/ts-shared';

import { UserEntityData } from './UserEntityData';
import { useEntityData } from '../../util/consumer/EntityConsumerHook';

export const useUserEntityData = () => useEntityData<UserModel>(UserEntityData);
